import React, { useContext, useEffect } from "react";
import { Routes, Route, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
/// Css
import "./../index.css";
import "./../chart.css";
import "./../step.css";

/// Layout
import Nav from "./../layouts/nav";
import Footer from "./../layouts/Footer";
import ZeroStateScreen from "./../pages/dashboard/ZeroStateScreen";

import { ThemeContext } from "../../context/ThemeContext";
//Scroll To Top
import ScrollToTop from "./../layouts/ScrollToTop";
import {
  appApi,
  useGetAllProjectsForMatrixQuery,
  useGetCurrentUserQuery,
} from "../../store/appApi";
import {
  selectUserRole,
  selectIsAuthenticated,
  refreshModules,
} from "../../store/authSlice";

/// Dashboard
import Home from "./../pages/dashboard/Home";
import ProjectDashboard from "./../pages/dashboard/ProjectDashboard";
import ProjectWorkspace from "./../pages/dashboard/ProjectWorkspace";
import EmptyPage from "./../pages/dashboard/EmptyPage";
// Projects
import AllProjects from "../pages/company/AllProjects";
import AddProject from "../pages/company/AddProject";
import ProjectCategory from "../pages/company/ProjectCategory";
//companies
import AllCompanies from "../pages/company/AllCompnies";
import AddCompany from "../pages/company/AddCompany";
import ProfileCompany from "../pages/company/ProfileCompany";
import CompanyCategory from "../pages/company/CompanyCategory";

//Student
import AllCustomers from "../pages/customers/AllCustomers";
import AddCustomer from "../pages/customers/AddCustomers";

//library
import AllLibrary from "./../pages/library/AllLibrary";
import AddLibrary from "./../pages/library/AddLibrary";
import EditLibrary from "./../pages/library/EditLibrary";

//Department
import AllDepartments from "./../pages/departments/AllDepartments";
import AddDepartments from "./../pages/departments/AddDepartments";
import EditDepartments from "./../pages/departments/EditDepartments";

//Workforce
import MovementRegister from "./../pages/workforce/MovementRegister";

//Staff
import AllStaff from "./../pages/staff/AllStaff";
import AddStaff from "./../pages/staff/AddStaff";
import EditStaff from "./../pages/staff/EditStaff";
import ProfileStaff from "./../pages/staff/ProfileStaff";
import ResetPassword from "./../pages/staff/ResetPassword";

// Attendance
import Punch from "./../pages/staff/attendance/Punch";
import MyCalendar from "./../pages/staff/attendance/MyCalendar";
import AdminRoster from "./../pages/staff/attendance/AdminRoster";
import WorkingHoursSheet from "./../pages/staff/attendance/WorkingHoursSheet";
import PunchLocation from "./../pages/staff/attendance/PunchLocation";
import EmployeeMonthView from "./../pages/staff/attendance/EmployeeMonthView";
import WorkplaceSettings from "./../pages/staff/attendance/WorkplaceSettings";

// Leave
import Apply from "./../pages/staff/leave/Apply";
import LeaveList from "./../pages/staff/leave/LeaveList";
import LeaveDetail from "./../pages/staff/leave/LeaveDetail";

// Contract Workers (isolated feature module — own folder / services / API)
import CreateContractWorker from "./../pages/contractWorkers/CreateContractWorker";
import EditContractWorker from "./../pages/contractWorkers/EditContractWorker";
import ContractWorkerAttendance from "./../pages/contractWorkers/ContractWorkerAttendance";
import ContractWorkerRoster from "./../pages/contractWorkers/ContractWorkerRoster";
import ContractWorkerDailyRoster from "./../pages/contractWorkers/ContractWorkerDailyRoster";
import ContractWorkerCalendar from "./../pages/contractWorkers/ContractWorkerCalendar";
// Bank Accounts ("Netplus Banks") — isolated feature module
import BankAccounts from "./../pages/bankAccounts/Accounts";
import BankAccountLedger from "./../pages/bankAccounts/Ledger";
// My Tasks (Reports) — isolated feature module
import MyTasks from "./../pages/tasks/MyTasks";
import WorkList from "./../pages/tasks/WorkList";
import TaskDetail from "./../pages/tasks/TaskDetail";

//holidays
import AllHoliday from "../pages/holidays/AllHoliday";
import AddHoliday from "../pages/holidays/AddHoliday";
import EditHoliday from "../pages/holidays/EditHoliday";
import HolidayEvent from "../pages/holidays/HolidayEvent";
// supplier
import AddSupplier from "../pages/inventory/supplier/add/AddSupplier";
import SupplierList from "../pages/inventory/supplier/list/List";
import EditSupplier from "../pages/inventory/supplier/edit/Edit";
import SupplierProfile from "../pages/inventory/supplier/detail/SupplierDetails";
// contractor
import ContractorCategory from "../pages/inventory/contractor/category/ContractorCategory";
import AddContractor from "../pages/inventory/contractor/addcontractor/AddContractor";
import ContractorList from "../pages/inventory/contractor/list/List";
import EditContractor from "../pages/inventory/contractor/edit/Edit";

//Fees
// import RevenueCollection from "../pages/revenue/RevenueCollection";
// import AddFees from "../pages/revenue/AddFees";
// import FeesReceipt from "../pages/revenue/FeesReceipt";

/// App
import AppProfile from "./../pages/apps/AppProfile";
import PostDetails from "./../pages/apps/PostDetails";
import EditProfile from "../pages/apps/EditProfile";
import Calendar from "./../pages/apps/Calendar/Calendar";
import Compose from "./../pages/email/Compose/Compose";
import Inbox from "./../pages/email/Inbox/Inbox";
import Read from "./../pages/email/Read";
/// Product List
import ProductGrid from "./../pages/ecommerce/ProductGrid/ProductGrid";
import ProductList from "./../pages/ecommerce/ProductList/ProductList";
import ProductDetail from "./../pages/ecommerce/ProductGrid/ProductDetail";
import Checkout from "./../pages/ecommerce/Checkout";
import EcomCustomers from "./../pages/ecommerce/Customers";
import Invoice from "./../pages/ecommerce/Invoice";
import ProductOrder from "./../pages/ecommerce/ProductOrder";

/// Charts
import RechartJs from "./../pages/charts/rechart";
import ChartJs from "./../pages/charts/Chartjs";
import SparklineChart from "./../pages/charts/Sparkline";
import ApexChart from "./../pages/charts/apexcharts";

/// Bootstrap
import UiAlert from "./../pages/bootstrap/Alert";
import UiAccordion from "./../pages/bootstrap/Accordion";
import UiBadge from "./../pages/bootstrap/Badge";
import UiButton from "./../pages/bootstrap/Button";
import UiModal from "./../pages/bootstrap/Modal";
import UiButtonGroup from "./../pages/bootstrap/ButtonGroup";
import UiListGroup from "./../pages/bootstrap/ListGroup";
import MediaObject from "./../pages/bootstrap/MediaObject";
import UiCards from "./../pages/bootstrap/Cards";
import UiCarousel from "./../pages/bootstrap/Carousel";
import UiDropDown from "./../pages/bootstrap/DropDown";
import UiPopOver from "./../pages/bootstrap/PopOver";
import UiProgressBar from "./../pages/bootstrap/ProgressBar";
import UiTab from "./../pages/bootstrap/Tab";
import UiPagination from "./../pages/bootstrap/Pagination";
import UiGrid from "./../pages/bootstrap/Grid";
import UiTypography from "./../pages/bootstrap/Typography";

/// Plugins
import Select2 from "./../pages/plugins/Select2/Select2";
import MainSweetAlert from "./../pages/plugins/SweetAlert";
import Toastr from "./../pages/plugins/Toastr";
import Lightgallery from "./../pages/plugins/Lightgallery";

/// Widget
import WidgetCard from "./../pages/widget/WidgetCard";
import WidgetChart from "./../pages/widget/WidgetChart";
import WidgetList from "./../pages/widget/WidgetList";

/// Table
import DataTable from "./../pages/table/DataTable";
import BootstrapTable from "./../pages/table/BootstrapTable";
import SortingTable from "./../pages/table/SortingTable/SortingTable";
import FilteringTable from "./../pages/table/FilteringTable/FilteringTable";

/// Form
import Element from "./../pages/forms/Element/Element";
import Wizard from "./../pages/forms/Wizard/Wizard";
import Pickers from "./../pages/forms/Pickers/Pickers";
import CkEditor from "./../pages/forms/CkEditor/CkEditor";
import FormValidation from "./../pages/forms/FormValidation/FormValidation";

/// Pages
import LockScreen from "./../pages/error/LockScreen";
import Error400 from "./../pages/error/Error400";
import Error403 from "./../pages/error/Error403";
import Error404 from "./../pages/error/Error404";
import Error500 from "./../pages/error/Error500";
import Error503 from "./../pages/error/Error503";
import AccessDenied from "./../pages/error/AccessDenied";

import RevenueCollection from "../pages/revenue/RevenueCollection";
import AllSessions from "../pages/sessions/AllSessions";
import CommissionSettings from "../pages/commission/CommissionSettings";
import WithdrawalRequests from "../pages/withdrawals/WithdrawalRequests";
import VehicleExpenses from "../pages/vehicle/VehicleExpenses";
import AllVehicles from "../pages/vehicle/List";
import AddVehicle from "../pages/vehicle/Add";
import AssignVehicle from "../pages/vehicle/AssignVehicle";
import AssignedDetail from "../pages/vehicle/AssignedDetail";
import CreateSku from "../pages/inventory/store/CreateSku";
import Store from "../pages/inventory/store/List";
import SkuLedger from "../pages/inventory/store/SkuLedger";
// finance
import ExpenseList from "../pages/finance/ExpenseList";
import AddExpenseForm from "../pages/finance/AddExpenseForm";
import CreateHead from "../pages/finance/CreateHead";
import CategorySummary from "../pages/finance/CategorySummary";
import CategoryDetail from "../pages/finance/CategoryDetail";
import VehicleSummary from "../pages/finance/VehicleSummary";
import VehicleDetail from "../pages/finance/VehicleDetail";
import ContractorDetail from "../pages/finance/ContractorDetail";
import SupplierDetail from "../pages/finance/SupplierDetail";
import AddType from "../pages/labour/AddType";
import LabourSummary from "../pages/labour/LabourSummary";
import LabourDetail from "../pages/labour/LabourDetail";
import IssueStock from "../pages/inventory/store/Issue";
import EditRequests from "../pages/inventory/store/EditRequests";
import StaffReportingPmCombined from "../pages/staffreporting/PmCombined";
import RealEstateTeams from "../pages/realestateteam/Teams";
import RealEstateClubReport from "../pages/realestateteam/ClubReport";
import NetplusTeams from "../pages/netplusteam/Teams";
import NetplusReports from "../pages/netplusteam/NetplusReports";
import DailySummary from "../pages/reports/DailySummary";
import AddAsset from "../pages/assets/AddAsset";
import AssetList from "../pages/assets/AssetList";
import AddEquipement from "../pages/progress/equipement/Add";
import ListEquipement from "../pages/progress/equipement/List";
import EquipmentServiceLogs from "../pages/progress/equipement/Detail";
import EquipmentDetail from "../pages/progress/equipement/EquipmentDetail";
import RelocateEquipment from "../pages/progress/equipement/Relocate";
import ServiceLogs from "../pages/progress/equipement/ServiceLogs";
import AddWorkProgress from "../pages/progress/workprogress/Add";
import ListWorkProgress from "../pages/progress/workprogress/List";
import DetailWorkProgress from "../pages/progress/workprogress/Detail";
import EditWorkProgress from "../pages/progress/workprogress/Edit";
import AddDailyMaterial from "../pages/progress/dailymaterial/Add";
import ListDailyMaterial from "../pages/progress/dailymaterial/List";
import DetailDailyMaterial from "../pages/progress/dailymaterial/Detail";
import EditDailyMaterial from "../pages/progress/dailymaterial/Edit";
import StaffReportingCreate from "../pages/staffreporting/Create";
import StaffReportingList from "../pages/staffreporting/List";
import StaffReportingDetail from "../pages/staffreporting/Detail";
import StaffReportingEmployeeReports from "../pages/staffreporting/EmployeeReports";
import StaffReportingBulkImport from "../pages/staffreporting/BulkImport";
import StaffReportingMasterCustomers from "../pages/staffreporting/MasterCustomers";
import StaffReportingVisitors from "../pages/staffreporting/Visitors";
import StaffReportingTeamEfforts from "../pages/staffreporting/TeamEfforts";
import AddAdvance from "../pages/advances/Add";
import AdvancesList from "../pages/advances/List";
import AdvanceDetail from "../pages/advances/Detail";
import AddCp from "../pages/cpDatabase/Add";
import CpDatabaseList from "../pages/cpDatabase/List";
import ChatPage from "../pages/chat/ChatPage";
import AddNetplusReceipt from "../pages/netplus/Add";
import NetplusList from "../pages/netplus/List";
import NetplusTransfersList from "../pages/netplus/TransfersList";
import NetplusModemList from "../pages/netplus/modem/List";
import ScanModem from "../pages/netplus/ScanModem";
import ModemRecoveryList from "../pages/netplus/modemRecovery/List";
import UntraceableList from "../pages/netplus/untraceable/List";
import NcsDashboard from "../pages/netplus/customerStatus/Dashboard";
import NcsUpload from "../pages/netplus/customerStatus/Upload";
import NcsCustomers from "../pages/netplus/customerStatus/Customers";
import NcsNewConnections from "../pages/netplus/customerStatus/NewConnections";
import NcsFollowups from "../pages/netplus/customerStatus/Followups";
import NcsTransitions from "../pages/netplus/customerStatus/Transitions";
import NcsDailyReport from "../pages/netplus/customerStatus/DailyReport";
import NcsModemRecovery from "../pages/netplus/customerStatus/ModemRecovery";
import NcsModemHandover from "../pages/netplus/customerStatus/ModemHandover";
import NcsReconciliation from "../pages/netplus/customerStatus/Reconciliation";
import NcsTeam from "../pages/netplus/customerStatus/Team";
import NcsAuditLog from "../pages/netplus/customerStatus/AuditLog";
import NcsPerformance from "../pages/netplus/customerStatus/Performance";
import NcsIncentive from "../pages/netplus/customerStatus/Incentive";
import NcsEmployeeDaily from "../pages/netplus/customerStatus/EmployeeDaily";
import NcsMyDaily from "../pages/netplus/customerStatus/MyDaily";
import NcsFreelancer from "../pages/netplus/customerStatus/Freelancer";
import NcmpUpload from "../pages/netplus/complaints/Upload";
import NcmpList from "../pages/netplus/complaints/List";
import SalesPage from "../pages/sales/Sales";
import PerformanceReview from "../pages/performanceReview/PerformanceReview";
import KittyReport from "../pages/kittyReport/KittyReport";
import HotelFeedback from "../pages/hotelFeedback/Feedback";
import HotelFeedbackList from "../pages/hotelFeedback/FeedbackList";
import NcsBankRecon from "../pages/netplus/bankRecon/BankRecon";
import SalarySheet from "../pages/salarySheet/SalarySheet";
import MyImprest from "../pages/imprest/MyImprest";
import AllotImprest from "../pages/imprest/Allot";
import ImprestAdminList from "../pages/imprest/AdminList";
import AdminEmployeeImprestPage from "../pages/imprest/AdminEmployeeImprestPage";
import ProjectExpensesReport from "../pages/imprest/ProjectExpensesReport";
import MdScheduleCreate from "../pages/schdule/Create";
import MdScheduleList from "../pages/schdule/List";

// Reports pages (Daily Report Summary, Netplus Banks, My Tasks, Work List) are
// restricted to a single user. Keep in sync with Menu.jsx and the backend's
// middleware/reportsAccess.js.
const REPORTS_USER_IDS = ["6aa647b116033bff40dc58f4"];
const ReportsGuard = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const allowed = REPORTS_USER_IDS.includes(String(user?.localId ?? ""));
  return allowed ? children : <AccessDenied />;
};
const reportsOnly = (component) => <ReportsGuard>{component}</ReportsGuard>;

// PM Combined Report — Project Managers (their own team) and super-admin only.
// Mirrors the backend check in getPmCombinedReport.
const PmGuard = ({ children }) => {
  const role = useSelector((state) => state.auth.user?.role);
  return role === "super-admin" || role === "Project Manager" ? children : <AccessDenied />;
};

const Markup = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  // Fetch fresh permissions from DB on every app load so module access
  // reflects the latest state set by admin, not just what was in the JWT.
  const { data: meData } = useGetCurrentUserQuery(undefined, {
    skip: !isAuthenticated,
  });
  useEffect(() => {
    if (meData?.user) {
      dispatch(refreshModules(meData.user));
    }
  }, [meData, dispatch]);

  // Intercept 403 module_forbidden responses to immediately re-fetch permissions
  // so the UI hides write controls when an admin revokes access mid-session.
  useEffect(() => {
    const id = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        if (
          err?.response?.status === 403 &&
          err?.response?.data?.reason === "module_forbidden"
        ) {
          dispatch(appApi.util.invalidateTags(["CurrentUser"]));
        }
        return Promise.reject(err);
      },
    );
    return () => axios.interceptors.response.eject(id);
  }, [dispatch]);

  const allroutes = [
    /// Dashboard — project selection is the entry point
    { url: "", component: <ProjectDashboard /> },
    { url: "dashboard", component: <ProjectDashboard /> },
    { url: "dashboard/home", component: <Home /> },
    //Companies
    { url: "companies", component: <AllCompanies /> },
    { url: "add-company", component: <AddCompany /> },
    { url: "company-profile", component: <ProfileCompany /> },
    { url: "company-categories", component: <CompanyCategory /> },
    //  projects
    { url: "projects", component: <AllProjects /> },
    { url: "add-project", component: <AddProject /> },
    { url: "project-categories", component: <ProjectCategory /> },
    // labour
    { url: "labour-type", component: <AddType /> },
    //Customer
    { url: "all-customers", component: <AllCustomers /> },
    { url: "add-customer", component: <AddCustomer /> },

    // sessions
    { url: "all-sessions", component: <AllSessions /> },
    //Library
    { url: "all-library", component: <AllLibrary /> },
    { url: "Add-library", component: <AddLibrary /> },
    { url: "edit-library", component: <EditLibrary /> },

    //Department
    { url: "All-departments", component: <AllDepartments /> },
    { url: "add-departments", component: <AddDepartments /> },
    { url: "edit-departments", component: <EditDepartments /> },

    //Staff
    { url: "all-staff", component: <AllStaff /> },
    { url: "add-staff", component: <AddStaff /> },
    { url: "edit-staff/:id", component: <EditStaff /> },
    { url: "staff-profile/:id", component: <ProfileStaff /> },
    { url: "staff/reset-password", component: <ResetPassword /> },
    { url: "movement-register", component: <MovementRegister /> },
    { url: "staff-reporting", component: <StaffReportingList /> },
    { url: "staff-reporting/create", component: <StaffReportingCreate /> },
    {
      url: "staff-reporting/customers",
      component: <StaffReportingMasterCustomers />,
    },
    {
      url: "staff-reporting/visitors",
      component: <StaffReportingVisitors />,
    },
    {
      url: "staff-reporting/bulk-import",
      component: <StaffReportingBulkImport />,
    },
    {
      url: "staff-reporting/employee/:employeeId",
      component: <StaffReportingEmployeeReports />,
    },
    {
      url: "staff-reporting/efforts",
      component: <StaffReportingTeamEfforts />,
    },
    { url: "staff-reporting/pm-combined", component: <PmGuard><StaffReportingPmCombined /></PmGuard> },
    { url: "real-estate-team", component: <RealEstateTeams /> },
    { url: "real-estate-team/club-report", component: <RealEstateClubReport /> },
    { url: "reports/daily-summary", component: reportsOnly(<DailySummary />) },
    { url: "netplus-team", component: <NetplusTeams /> },
    { url: "netplus-team/reports", component: <NetplusReports /> },
    { url: "staff-reporting/:id", component: <StaffReportingDetail /> },
    { url: "advances", component: <AdvancesList /> },
    { url: "advances/add", component: <AddAdvance /> },
    { url: "advances/:employeeId", component: <AdvanceDetail /> },
    { url: "cp-database", component: <CpDatabaseList /> },
    { url: "cp-database/add", component: <AddCp /> },
    { url: "cp-database/edit/:id", component: <AddCp /> },
    { url: "chat", component: <ChatPage /> },
    { url: "netplus", component: <NetplusList /> },
    { url: "netplus/add", component: <AddNetplusReceipt /> },
    { url: "netplus/transfers", component: <NetplusTransfersList /> },
    { url: "netplus/modem-status", component: <NetplusModemList /> },
    { url: "netplus/customer-status", component: <NcsDashboard /> },
    { url: "netplus/customer-status/upload", component: <NcsUpload /> },
    { url: "netplus/customer-status/customers", component: <NcsCustomers /> },
    {
      url: "netplus/customer-status/new-connections",
      component: <NcsNewConnections />,
    },
    { url: "netplus/customer-status/followups", component: <NcsFollowups /> },
    { url: "netplus/customer-status/transitions", component: <NcsTransitions /> },
    { url: "netplus/customer-status/daily-report", component: <NcsDailyReport /> },
    { url: "netplus/customer-status/modem-recovery", component: <NcsModemRecovery /> },
    { url: "netplus/scan-modem", component: <ScanModem /> },
    {
      url: "netplus/customer-status/modem-handover",
      component: <NcsModemHandover />,
    },
    {
      url: "netplus/customer-status/reconciliation",
      component: <NcsReconciliation />,
    },
    { url: "netplus/customer-status/team", component: <NcsTeam /> },
    { url: "netplus/customer-status/audit", component: <NcsAuditLog /> },
    { url: "netplus/customer-status/performance", component: <NcsPerformance /> },
    { url: "netplus/customer-status/incentive", component: <NcsIncentive /> },
    {
      url: "netplus/customer-status/employee-daily",
      component: <NcsEmployeeDaily />,
    },
    { url: "netplus/customer-status/my-daily", component: <NcsMyDaily /> },
    { url: "netplus/customer-status/freelancer", component: <NcsFreelancer /> },
    { url: "netplus/complaints/upload", component: <NcmpUpload /> },
    { url: "netplus/complaints/list", component: <NcmpList /> },
    { url: "sales", component: <SalesPage /> },
    { url: "performance-review", component: <PerformanceReview /> },
    { url: "salary-sheet", component: <SalarySheet /> },
    { url: "kitty-report", component: <KittyReport /> },
    { url: "hotel-feedback", component: <HotelFeedback /> },
    { url: "hotel-feedback/list", component: <HotelFeedbackList /> },
    { url: "netplus/bank-recon", component: <NcsBankRecon /> },
    // Not linked from the nav yet — reachable by direct URL for review only.
    { url: "modem-recovery", component: <ModemRecoveryList /> },
    { url: "untraceable-cases", component: <UntraceableList /> },
    { url: "imprest", component: <MyImprest /> },
    { url: "imprest/allot", component: <AllotImprest /> },
    { url: "imprest/admin", component: <ImprestAdminList /> },
    { url: "imprest/admin/:employeeId", component: <AdminEmployeeImprestPage /> },
    { url: "imprest/expenses-report", component: <ProjectExpensesReport /> },
    { url: "md-schedule", component: <MdScheduleList /> },
    { url: "md-schedule/create", component: <MdScheduleCreate /> },
    // Attendance
    { url: "staff/attendance/punch", component: <Punch /> },
    { url: "staff/attendance/calendar", component: <MyCalendar /> },
    { url: "staff/attendance/roster", component: <AdminRoster /> },
    { url: "staff/attendance/working-hours", component: <WorkingHoursSheet /> },
    { url: "staff/attendance/location", component: <PunchLocation /> },
    { url: "staff/attendance/employee/:id", component: <EmployeeMonthView /> },
    {
      url: "staff/attendance/workplace-settings",
      component: <WorkplaceSettings />,
    },
    // Leave
    { url: "staff/leave/apply", component: <Apply /> },
    { url: "staff/leave/list", component: <LeaveList /> },
    { url: "staff/leave/:id", component: <LeaveDetail /> },
    // Contract Workers (isolated feature module)
    { url: "contract-workers/add", component: <CreateContractWorker /> },
    { url: "contract-workers/edit/:id", component: <EditContractWorker /> },
    {
      url: "contract-workers/attendance",
      component: <ContractWorkerAttendance />,
    },
    { url: "contract-workers/roster", component: <ContractWorkerRoster /> },
    {
      url: "contract-workers/daily-roster",
      component: <ContractWorkerDailyRoster />,
    },
    {
      url: "contract-workers/worker/:id",
      component: <ContractWorkerCalendar />,
    },
    // Bank Accounts ("Netplus Banks", isolated feature module, under Reports)
    { url: "bank-accounts", component: reportsOnly(<BankAccounts />) },
    { url: "bank-accounts/:id", component: reportsOnly(<BankAccountLedger />) },
    { url: "tasks", component: reportsOnly(<MyTasks />) },
    { url: "tasks/work-list", component: reportsOnly(<WorkList />) },
    { url: "tasks/:id", component: reportsOnly(<TaskDetail />) },
    // Suppliers
    { url: "add-supplier", component: <AddSupplier /> },
    { url: "supplier-list", component: <SupplierList /> },
    { url: "edit-supplier/:id", component: <EditSupplier /> },
    { url: "supplier-profile/:id", component: <SupplierProfile /> },
    { url: "contractor-payments", component: <ContractorDetail /> },
    // contractors
    { url: "contractor-categories", component: <ContractorCategory /> },
    { url: "contractor-list", component: <ContractorList /> },
    { url: "add-contractor", component: <AddContractor /> },
    { url: "edit-contractor/:id", component: <EditContractor /> },
    { url: "supplier-payments", component: <SupplierDetail /> },
    //Holiday
    { url: "all-holiday", component: <AllHoliday /> },
    { url: "add-holiday", component: <AddHoliday /> },
    { url: "edit-holiday", component: <EditHoliday /> },
    { url: "holiday-calendar", component: <HolidayEvent /> },
    // vehicle
    { url: "vehicles", component: <AllVehicles /> },
    { url: "add-vehicle", component: <AddVehicle /> },
    { url: "vehicle/expenses", component: <VehicleExpenses /> },
    { url: "vehicle/assign", component: <AssignVehicle /> },
    { url: "vehicle/:id/history", component: <AssignedDetail /> },

    // Inventory / Store
    { url: "inventory/sku", component: <CreateSku /> },
    { url: "inventory/store", component: <Store /> },
    { url: "inventory/issue", component: <IssueStock /> },
    { url: "inventory/edit-requests", component: <EditRequests /> },
    { url: "inventory/sku/:skuId/ledger", component: <SkuLedger /> },
    //fees
    { url: "revenue-collection", component: <RevenueCollection /> },

    // Finance / Expenses
    { url: "expenses", component: <ExpenseList /> },
    { url: "payments", component: <ExpenseList /> },
    { url: "category-heads", component: <CreateHead /> },
    { url: "finance/category-summary", component: <CategorySummary /> },
    { url: "finance/category-detail/:id", component: <CategoryDetail /> },
    { url: "finance/vehicle-summary", component: <VehicleSummary /> },
    { url: "finance/vehicle-detail/:id", component: <VehicleDetail /> },
    { url: "finance/contractor-detail/:id", component: <ContractorDetail /> },
    { url: "finance/supplier-detail/:id", component: <SupplierDetail /> },
    { url: "finance/labour-summary", component: <LabourSummary /> },
    { url: "finance/labour-detail/:id", component: <LabourDetail /> },
    // daily progress report — equipment
    // Static routes must come before dynamic (:id) routes to avoid conflicts
    { url: "assets/add", component: <AddAsset /> },
    { url: "assets/list", component: <AssetList /> },
    { url: "assets/edit/:id", component: <AddAsset /> },
    { url: "progress/equipement/add", component: <AddEquipement /> },
    { url: "progress/equipement/list", component: <ListEquipement /> },
    { url: "progress/equipement/detail", component: <EquipmentServiceLogs /> },
    { url: "progress/equipement/service-logs", component: <ServiceLogs /> },
    { url: "progress/equipement/relocate", component: <RelocateEquipment /> },
    { url: "progress/equipement/:id/view", component: <EquipmentDetail /> },
    {
      url: "progress/equipement/:id/detail",
      component: <EquipmentServiceLogs />,
    },
    // daily progress report — work progress
    { url: "progress/workprogress/add", component: <AddWorkProgress /> },
    { url: "progress/workprogress/list", component: <ListWorkProgress /> },
    {
      url: "progress/workprogress/detail/:id",
      component: <DetailWorkProgress />,
    },
    { url: "progress/workprogress/edit/:id", component: <EditWorkProgress /> },
    // daily material progress report
    { url: "progress/daily-material/add", component: <AddDailyMaterial /> },
    { url: "progress/daily-material/list", component: <ListDailyMaterial /> },
    {
      url: "progress/daily-material/detail/:id",
      component: <DetailDailyMaterial />,
    },
    {
      url: "progress/daily-material/edit/:id",
      component: <EditDailyMaterial />,
    },
    { url: "add/expense", component: <AddExpenseForm /> },
    { url: "commission-settings", component: <CommissionSettings /> },
    { url: "withdrawal-requests", component: <WithdrawalRequests /> },
    // { url: "add-fees", component: <AddFees /> },
    // { url: "fees-receipt", component: <FeesReceipt /> },

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "post-details", component: <PostDetails /> },
    { url: "edit-profile", component: <EditProfile /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },
    /// Shop
    { url: "ecom-product-grid", component: <ProductGrid /> },
    { url: "ecom-product-list", component: <ProductList /> },
    { url: "ecom-product-detail", component: <ProductDetail /> },
    { url: "ecom-product-order", component: <ProductOrder /> },
    { url: "ecom-checkout", component: <Checkout /> },
    { url: "ecom-invoice", component: <Invoice /> },
    { url: "ecom-customers", component: <EcomCustomers /> },

    /// Chart
    { url: "chart-sparkline", component: <SparklineChart /> },
    { url: "chart-chartjs", component: <ChartJs /> },
    { url: "chart-apexchart", component: <ApexChart /> },
    { url: "chart-rechart", component: <RechartJs /> },

    /// Bootstrap
    { url: "ui-accordion", component: <UiAccordion /> },
    { url: "ui-alert", component: <UiAlert /> },
    { url: "ui-badge", component: <UiBadge /> },
    { url: "ui-button", component: <UiButton /> },
    { url: "ui-modal", component: <UiModal /> },
    { url: "ui-button-group", component: <UiButtonGroup /> },
    { url: "ui-list-group", component: <UiListGroup /> },
    { url: "ui-media-object", component: <MediaObject /> },
    { url: "ui-card", component: <UiCards /> },
    { url: "ui-carousel", component: <UiCarousel /> },
    { url: "ui-dropdown", component: <UiDropDown /> },
    { url: "ui-popover", component: <UiPopOver /> },
    { url: "ui-progressbar", component: <UiProgressBar /> },
    { url: "ui-tab", component: <UiTab /> },
    { url: "ui-pagination", component: <UiPagination /> },
    { url: "ui-typography", component: <UiTypography /> },
    { url: "ui-grid", component: <UiGrid /> },

    /// Plugin

    { url: "uc-select2", component: <Select2 /> },
    { url: "uc-sweetalert", component: <MainSweetAlert /> },
    { url: "uc-toastr", component: <Toastr /> },
    // { url: "map-jqvmap", component: <JqvMap /> },
    { url: "uc-lightgallery", component: <Lightgallery /> },

    /// Widget
    { url: "widget-card", component: <WidgetCard /> },
    { url: "widget-chart", component: <WidgetChart /> },
    { url: "widget-list", component: <WidgetList /> },

    // Form
    { url: "form-element", component: <Element /> },
    { url: "form-wizard", component: <Wizard /> },
    { url: "form-ckeditor", component: <CkEditor /> },
    { url: "form-pickers", component: <Pickers /> },
    { url: "form-validation", component: <FormValidation /> },

    /// table
    { url: "table-datatable-basic", component: <DataTable /> },
    { url: "table-filtering", component: <FilteringTable /> },
    { url: "table-sorting", component: <SortingTable /> },
    { url: "table-bootstrap-basic", component: <BootstrapTable /> },

    /// pages
    { url: "empty", component: <EmptyPage /> },
    // { url: 'todo', component: <Todo/> },
  ];

  function NotFound() {
    const url = allroutes.map((route) => route.url);
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    if (url.indexOf(path) <= 0) {
      return <Error404 />;
    }
  }

  return (
    <>
      <Routes>
        <Route path="/page-lock-screen" element={<LockScreen />} />
        <Route path="/page-error-400" element={<Error400 />} />
        <Route path="/page-error-403" element={<Error403 />} />
        <Route path="/page-error-404" element={<Error404 />} />
        <Route path="/page-error-500" element={<Error500 />} />
        <Route path="/page-error-503" element={<Error503 />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
          {/* Project-scoped workspace — validates assignment then renders children */}
          <Route
            path="dashboard/project/:projectId"
            element={<ProjectWorkspace />}
          >
            <Route index element={<Home />} />
            {allroutes
              .filter(
                (r) =>
                  r.url &&
                  r.url !== "" &&
                  r.url !== "dashboard" &&
                  r.url !== "dashboard/home",
              )
              .map((data, i) => (
                <Route
                  key={`proj-${i}`}
                  path={data.url}
                  element={data.component}
                />
              ))}
          </Route>
        </Route>
        <Route path="/:locale" element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={`locale-${i}`}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector((state) => state.sideMenu);
  const userRole = useSelector(selectUserRole);
  const isSuperAdmin = userRole === "super-admin";
  const location = useLocation();

  // Admin gate: verify project count before allowing access to any route.
  // Non-admins skip this query entirely.
  const { data: allProjectsData, isLoading: projectsLoading } =
    useGetAllProjectsForMatrixQuery(undefined, { skip: !isSuperAdmin });

  // While checking if admin has any projects, show a spinner so we don't
  // flash the full layout before knowing we need the zero-state screen.
  if (isSuperAdmin && projectsLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading…</span>
        </div>
      </div>
    );
  }

  // Admin with no projects: block ALL routes — they must create one first.
  if (isSuperAdmin) {
    const allProjects =
      allProjectsData?.data ?? allProjectsData?.projects ?? [];
    if (allProjects.length === 0) {
      return <ZeroStateScreen />;
    }
  }

  // Root dashboard path: all users see the project-selection screen (no nav).
  // This covers "/", "/dashboard", and "/dashboard/" — normalised below.
  const path = location.pathname.replace(/\/$/, "") || "/";
  const isRootDashboard = path === "/" || path === "/dashboard";
  if (isRootDashboard) {
    return <ZeroStateScreen />;
  }

  return (
    <>
      <div
        id="main-wrapper"
        className={`show  ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}
      >
        <Nav />
        <div className="content-body">
          <div
            className="container-fluid"
            style={{ minHeight: window.screen.height - 45 }}
          >
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Markup;
